export default __webpack_public_path__ + "static/media/mh.72a00010.svg";